import AchievementList from 'components/achievement/AchievementList.vue'
import AchievementEdit from 'components/achievement/AchievementEdit.vue'
import AchievementBatchEdit from 'components/achievement/AchievementBatchEdit.vue'
import AchievementView from 'components/achievement/AchievementView.vue'

// 成果
export let achievement_list = {
  path: 'achievement/list',
  component: AchievementList,
}
export let achievement_edit = {
  path: 'achievement/edit',
  component: AchievementEdit,
}
export let achievement_batch_edit = {
  path: 'achievement/batch/edit',
  component: AchievementBatchEdit,
}
export let achievement_view = {
  path: 'achievement/view',
  component: AchievementView,
}

export let achievement_routes = [
  achievement_list,
  achievement_edit,
  achievement_view,
  achievement_batch_edit,
]

export let achievement_map = {
  achievement_list,
  achievement_edit,
  achievement_view,
  achievement_batch_edit,
}



// WEBPACK FOOTER //
// ./src/router/routes/home/achievement.js